
import React from 'react';

import {connect} from "react-redux";
import * as rateUtils from "../../utils/underwriterRate";
import l10n from "../../l10n/localization";
import * as rateActions from "../../actions/underwriterRate";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/underwriterRate';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class UnderwriterRateForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item.item,
            fog: this.props.item.fog,
            underwriter: this.props.item.underwriter,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.underwriter.rate.name
                    },
                    rate: {
                        type: "number",
                        title: l10n.underwriter.rate.rate,
                    },
                    yearOfAddition: {
                        type: "number",
                        title: l10n.underwriter.rate.yearOfAddition,
                    },
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                yearOfAddition: {
                    "ui:widget": "updown"
                },
            },
            fields: {},
            isDirty: false,
            formData: rateUtils.underwriterRateToForm(this.props.item.item)
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});
        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                form.company = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.underwriter.id : (utilsCommon.notNullNorUndefined(this.state.underwriter) ? this.state.underwriter.id : null);
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    if (form.creationDate !== undefined) {
                        delete form.creationDate;
                    }
                    this.props.dispatch(rateActions.edit(form));
                })
            } else {
                form.company = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.underwriter.id : (utilsCommon.notNullNorUndefined(this.state.underwriter) ? this.state.underwriter.id : null);
                this.setState({item: formData}, () => {
                    if (form.creationDate !== undefined) {
                        delete form.creationDate;
                    }
                    this.props.dispatch(rateActions.edit(form));
                })
            }
        } else {
            form.company = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.underwriter.id : (utilsCommon.notNullNorUndefined(this.state.underwriter) ? this.state.underwriter.id : null);
            this.setState({item: formData}, () => {
                this.props.dispatch(rateActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false, formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(rateActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'underwriter-rate-form dirty':'underwriter-rate-form';

        if (utilsCommon.notNullNorUndefined(this.props.item.fog) && utilsCommon.notNullNorUndefined(this.state.underwriter)) {
            return (
                <div>Please select a underwriter</div>
            )
        }

        if (utilsCommon.notNullNorUndefined(this.props.item.fog) && (this.props.item.fog.underwriter === undefined || this.props.item.fog.underwriter === null)) {
            return (
                <div>Please select a underwriter</div>
            )
        }

        if (this.props.loading) {
            return (<div><Loader /></div>)
        }

        console.log('// underwrite rate //');

        return (
            <div className={formClassName}>
                <h1>{l10n.common.underwriterRates}</h1>
                <CWForm
                    schema={this.state.schema}
                    formData={this.state.formData}
                    showErrorList={false}
                    fields={this.state.fields}
                    uiSchema={this.state.uiSchema}
                    validate={this.validate}
                    liveValidate={true}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onSubmit={this.onSubmit}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.underwriterRate.loading,
        saving: state.underwriterRate.saving,

        newlyCreatedElement: state.creation.newlyCreatedUnderwriterRate,
    });
})(UnderwriterRateForm);


// WEBPACK FOOTER //
// ./src/components/forms/UnderwriterRateForm.js